export default {"src":"/_next/static/media/RRC.6ae9f270.svg","height":18,"width":18};